import { Button, Input } from 'rsuite';
import React from 'react';
import { FormField, FormGrid, FormModal } from '../../common/FormModal';

type Props = {
  modalUserId: string;
  modalUserEmail: string;
  modalUserPassword: string;
  handleModalClose: () => void;
  setModalUserEmail: (value: string) => void;
  setModalUserPassword: (value: string) => void;
  submit: () => Promise<void>;
  errorSummary?: string[];
};

export default function EditUserModal({
  modalUserId,
  modalUserEmail,
  modalUserPassword,
  handleModalClose,
  setModalUserEmail,
  setModalUserPassword,
  submit,
  errorSummary = [],
}: Props) {
  return (
    <FormModal
      open={modalUserId.length > 0}
      onClose={handleModalClose}
      title="Редагувати користувача"
      errorSummary={errorSummary}
      footer={
        <>
          <Button onClick={submit} appearance="primary">
            Зберегти
          </Button>
          <Button onClick={handleModalClose} appearance="subtle">
            Скасувати
          </Button>
        </>
      }
    >
      <FormGrid>
        <FormField label="Пошта" id="edit-user-email" required>
          <Input
            value={modalUserEmail || ''}
            placeholder="Пошта"
            type="email"
            onChange={setModalUserEmail}
          />
        </FormField>
        <FormField label="Пароль" id="edit-user-password" required>
          <Input
            value={modalUserPassword || ''}
            placeholder="Пароль"
            type="password"
            onChange={setModalUserPassword}
          />
        </FormField>
      </FormGrid>
    </FormModal>
  );
}
